import React from "react";
import { Navigation } from "../components/navigation";
import { Header4 } from "../components/header";
import { AboutCmp } from "../components/about";



const About = () => {
    return ( 
        <div>
        <Navigation/>
        <Header4/>
        <AboutCmp/>
       </div>
    );
  };
  
 export default About;